// Google Analytics 4 — loaded ONLY after the user accepts cookies (see CookieConsent.js).
// Nothing here runs (and no GA cookie is set) until loadAnalytics() is called.
export const GA_MEASUREMENT_ID = 'G-5JG9XN237T';

let loaded = false;

export function loadAnalytics() {
  if (loaded || typeof window === 'undefined') return;
  if (document.getElementById('ga-gtag')) {
    loaded = true;
    return;
  }
  loaded = true;

  const script = document.createElement('script');
  script.id = 'ga-gtag';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  // send_page_view:false → we fire page_view manually so SPA route changes are counted once
  gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true, send_page_view: false });
}

export function trackPageView(path) {
  if (!loaded || typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
